<template>
    <div class="container-fluid">
        <v-title :breadcrumb="{label: 'Credit Memos', route: {name: 'credit-memos'}, root: true}">
            Credit Memos
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no Credit Memos</span>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vNoContent from '@/components/v-no-content';
    import FilterSet from '@/components/query/filter-set';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import creditMemoColumns from './credit-memo-columns';
    import creditMemoFilters from './credit-memo-filters';

    export default {
        components: {
            vTitle, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: creditMemoColumns,
                gridTabs: new TabsConfiguration({
                    id: 'credit-memos-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {updatedTime: 'desc'},
                        },
                    ],
                    version: 1,
                    filtersVersion: creditMemoFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...creditMemoFilters}),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({creditMemos}) => creditMemos.getAll(params));
            },
        },
    };
</script>
